import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="page-container flex min-h-[60vh] flex-col items-center justify-center py-16 text-center">
        <p className="font-heading text-[11px] font-semibold tracking-[0.24em] text-primary-600">404 NOT FOUND</p>
        <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          ページが見つかりませんでした
        </h1>
        <p className="mt-2 max-w-md text-[13px] leading-6 text-foreground-600">
          アドレスが変更されたか、削除された可能性があります。検索やランキングから作品を探してみてください。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <Link
            to="/"
            className="inline-flex h-11 items-center gap-1.5 rounded-md bg-primary-500 px-4 text-[13px] font-medium text-background-50 hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true" />
            トップページへ
          </Link>
          <Link
            to="/search"
            className="inline-flex h-11 items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 text-[13px] text-foreground-800 hover:bg-background-100"
          >
            <i className="ri-search-line" aria-hidden="true" />
            作品を検索
          </Link>
          <Link
            to="/ranking"
            className="inline-flex h-11 items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 text-[13px] text-foreground-800 hover:bg-background-100"
          >
            <i className="ri-bar-chart-2-line" aria-hidden="true" />
            ランキング
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}